import React from 'react'
import TaskMini from "./TaskMini"
import useFormApi from "../../../cmn/docAutomation/useFormApi"
import SarasDnDCard from '../../../../library/hooks/bdnd/SarasDnDCard';
import * as fn from '../../../../helper/uiFunctions';

const TaskDashRow = (props) => {
    const { formObject, viewData, rowKey, dashRowId, index } = props;
    const [popupData, setPopupData] = React.useState(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const dashRow = React.useRef();

    let formApi = useFormApi();

    const resetPopupData = () => {
        setPopupData(null);
    }

    React.useEffect(resetPopupData,[viewData,rowKey]);

    if (!viewData)
        return (null);

        
    //console.log("taskRow",viewData);
    //let data = viewData.childRows[0].rowValues;
    const url = fn.getShowDocumentLink(viewData.dataList.valLDT, viewData.rId, "", 1, viewData.dataList.module, viewData.dataList.view);

    const urlTarget = viewData.dataList.windowTarget ? viewData.dataList.windowTarget : "_blank";

    const getStyle = () => {
        if (viewData.dataList.recordBarStyle !== "") {
            //alert(data.recordBarContainer.dataList.colCssStyle)
            return JSON.parse(viewData.dataList.recordBarStyle)
        }
        else {
            return {color:"#000"}
        }
    }

    const loadPopupData = () => {
        let customAction = {
            actionId: "show",
            actionName: "dashComp",
            actionParam: {
                actionType: "",
                dshv_rowId: dashRowId,
                tdoctyid: viewData.dataList.valLDT,
                elementId: viewData.rId,
                hvCompDocTypeName: "Dashboard",
                sview: "D",
                vreload: 0,
                dshs_popup: 1
            },
            containerKey: "custom",
            onSuccess: onSuccess
        };

        formApi.runGenericAction(customAction, "dashComp", viewData, viewData.headerRows, { masterKeys: formObject.masterKeys }, "", "DashViews", 0, onSuccess);
    }

    const onRowHover = () => {
        // console.log("dash onRowHover")
        if (!popupData) {
            loadPopupData();
        }
        setIsOpen(true);
    }

    const renderDashPopup = () => {
        //console.log("dash renderDashPopup", isOpen && popupData != null);
        if (isOpen && popupData != null) {
            return (
                <TaskMini viewData={popupData} anchorRef={dashRow} />
            )
        }
        else {
            return (null)
        }
    }

    const hidePopup = () => {
        // console.log("dash hidePopup", viewData.dataList.taskTitle)
        setIsOpen(false);
    }

    const onSuccess = (action, containerKey, rowKey, headerKey, response) => {
        setPopupData(response.mainViewData);
    }

    return (
        <SarasDnDCard rowKey={rowKey} index={index}>
            <li>
                <div className="uiRecordContainer" >
                    <a href={url} target={urlTarget}>
                        <div className="uiBar" style={getStyle()}>
                            <div className="uiInline uiH110" >
                                <span>{viewData.dataList.taskTitle}</span>
                            </div>
                            <div ref={dashRow} className={`uiInline uiDashRowRCol show-popup ${viewData.dataList.taskPriorityStyle}`}
                                onMouseLeave={hidePopup} onMouseOver={onRowHover}
                            >
                                <span className="uiCenterLabel">{viewData.dataList.taskPriority}</span>
                                {
                                    renderDashPopup()
                                }
                            </div>
                        </div>
                        <div className="uiBarInfo uiH110" style={{ display: viewData.dataList.taskSubTitle ? "" : "none" }}>
                            <span>{viewData.dataList.taskSubTitle}</span>
                        </div>
                    </a>
                </div>
            </li>
        </SarasDnDCard>
    )
}

export default TaskDashRow